export default {"src":"/_next/static/media/smile.3481e8ba.gif","height":90,"width":90,"blurWidth":0,"blurHeight":0};